require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-ops-102-intro-to-computer-operations.json") })
        }
      }, "path---courses-ops-102-intro-to-computer-operations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-ops-102-intro-to-computer-operations!./.cache/json/courses-ops-102-intro-to-computer-operations.json
// module id = 1186
// module chunks = 231608221292675